import { useNavigate } from "react-router";
import { ChartMainCard } from "../LeadsDashboardComponents/ChartsHeader";
import { TeamAvailability } from "../LeadsDashboardComponents/StatCardIcons";
import StatusChip from "../ui/chip/status";
import DataNotFound from "../ui/loader/data-not-found";
import InnerLoader from "../ui/loader/inner-loader";

const statusColor = {
  completed: { background: "#E6F9F0", color: "#0F9D58" }, // emerald green
  on_hold: { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
  in_progress: { background: "#F3E8FF", color: "#9333EA" }, // violet
  revision: { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  "no answer update 2": { background: "#f3f4f6", color: "#374151" }, // cyan / teal
  "wrong number": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "call back": { background: "#fffbeb", color: "#78350f" }, // cyan / teal
  "not interested": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "do not contact": { background: "#f9fafb", color: "#374151" }, // cyan / teal
  duplicate: { background: "#ede9fe", color: "#5b21b6" },
};

export function RecentProjectTable({ data = [], apiLoading = true }) {
  const navigate = useNavigate();

  return (
    <ChartMainCard
      Icon={<TeamAvailability />}
      iconColor={"bg-theme-purple-light text-theme-purple"}
      // iconColor={"bg-[#FEE2E2] text-[#FF4040]"}
      heading="Latest Project Entries"
      subHeading={"Most recent prospects captured"}
    >
      {!apiLoading ? (
        <div className="max-h-[430px] min-h-[430px] overflow-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Invoice Id
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Project Cost ($)
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Payment Status
                </th>

                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Start Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                  Status
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {data.length > 0 ? (
                data?.map((lead) => (
                  <tr
                    key={lead.id}
                    className="hover:bg-gray-100 cursor-pointer transition-all duration-200"
                    onClick={() => {
                      // navigate(`/lead-account/detail/${lead?.customer_details?.userid}/project/${lead?.projectkey || lead?.project_key}`)
                      const nav = `/lead-account/detail/${lead?.customer_details?.userid}/project/${lead?.projectkey || lead?.project_key}`;

                      window.open(nav, "_blank"); // opens in a new tab
                    }}
                  >
                    <td className="px-6 py-4">
                      <h6 className="font-semibold text-sm">
                        {lead?.invoiceid ?? "-"}
                      </h6>
                    </td>
                    <td className="px-6 py-4">
                      <h6 className="font-semibold text-sm">
                        ${lead?.projectcost ? lead?.projectcost : "-"}
                      </h6>
                    </td>

                    <td className="px-6 py-4">
                      {lead.payment ? (
                        <StatusChip
                          color={
                            lead?.payment == "pending"
                              ? "blue"
                              : lead?.payment == "success"
                                ? "green"
                                : lead?.payment == "rejected"
                                  ? "red"
                                  : null
                          }
                        >
                          {lead?.payment || "--"}
                        </StatusChip>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className="px-6 py-4">{lead?.startdate ?? "-"}</td>
                    <td className="px-6 py-4 flex ">
                      <span
                        className={`flex items-center text-[12px] gap-2 px-4 py-[7px] rounded-full cursor-pointer transition-all duration-200
                                                  `}
                        style={
                          statusColor[lead?.status] || {
                            background: "#f5f5f5",
                            color: "#616161",
                          }
                        }
                      >
                        {lead?.status
                          ? lead?.status
                              ?.split("_")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" ")
                          : null}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <DataNotFound title={"Leads"} />
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <InnerLoader />
      )}
    </ChartMainCard>
  );
}
